import { FormControl, Grid, TextField } from '@mui/material'
import React from 'react'

export const CashReceipt = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputNumberChange } = FormScreen

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="monto_solicitado"> * Monto a ingresar</label>
                    <TextField
                        id='monto_solicitado'
                        name='monto_solicitado'
                        value={ formState.monto_solicitado_mask } 
                        onChange={ onInputNumberChange }
                        size='small'
                        placeholder='500.50, 100.00'
                        type='text'
                        variant={readOnlyMode? 'filled': 'outlined'}
                        hiddenLabel
                        InputProps={{
                            readOnly: readOnlyMode 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}
